<template>
<div>
    <smallbutton :toplabel="title" @click="Show()" v-if="showButton" :disabled="disabled" :class="buttonclass"/>
    <linkbutton :toplabel="title" @click="Show()" v-if="showLink" :disabled="disabled"/>
  
    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <label class="titlelabel">{{title}}</label>
            <label >{{body}}</label>
            <div>
                <smallbutton  @click="CloseWithYes" toplabel="Send"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import smallbutton from '../components/controls/button.vue'
import actionmodal from '../components/controls/actionmodal.vue'
import linkbutton from '../components/controls/linkbutton.vue'

export default {
    name:'sendvalidationemail',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,

    },
    props:{
        title:{
            type:String,
            required:true,
            default:'Send Validation Email'
        },
        body:{
            type:String,
            default:'We need to validate your email address. Please click Send and then check your email.'
        },


    },
    data(){
        return{
            responseMessage:''
        }
    },
    methods:{
        Show(){
            this.$refs.mymodal.openModal()
        },
        async CloseWithYes(){
            this.$emit('yes')
            this.$refs.mymodal.closeModal()
        }
    }
}
</script>

<style>

</style>